import React from 'react'

const ArrowSliderNext = props => (
  <svg
    width={props.width ? props.width : 10}
    height={props.height ? props.height : 18}
    viewBox='0 0 10 18'
    fill={props.color ? props.color : '#1D79FB'}
    className={props.className ? props.className : ''}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M0.0502138 16.0711L1.46443 17.4854L9.94971 9.00007L1.46443 0.514788L0.0502112 1.929L7.12128 9.00007L0.0502138 16.0711Z' />
  </svg>
)

export default ArrowSliderNext
